import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/SystemHelper`;

interface ILOVGroup {
    lovgroupcode: string;
}
interface IParentGroup {
    parentGroupCode: string;
    parentLOVCode: string;
}
class SystemHelperService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }

    public async getLOVByGroup(queries: ILOVGroup): Promise<IApiResponse | void> {
        try {
            const result = await super.get(queries, { name: "GetLOVByGroup" });
            return result;
        } catch (e) {
            throw e;
        }
    }
    public async getLOVByParent(queries: IParentGroup): Promise<IApiResponse | void> {
        try {
            const result = await super.get(queries, { name: "GetLOVByParent" });
            return result;
        } catch (e) {
            throw e;
        }
    }
    public getProjectTypeByOrg(orgId: number, source?: string | null): Promise<IApiResponse | void> {
        try {
            return super.get({ orgID: orgId, source: source }, { name: "GetProjectTypeByOrg" });
        } catch (e) {
            throw e;
        }
    }

    public getCurrency(year: number): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyData`;
            return super.get({ year });
        } catch (e) {
            throw e;
        }
        finally {
            this.url = url;
        }
    }

    public getCurrencyScreenList(): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyScreen/list`;
            return super.get();
        } catch (e) {
            throw e;
        }
        finally {
            this.url = url;
        }
    }

    public createCurrencyScreen(
        body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyScreen`;
            return super.create(body);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public updateCurrencyScreen(
        body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyScreen`;
            return super.update(body, '');
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public removeCurrencyScreen(body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyScreen`;
            return super.delete(undefined, null, body);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public updateCurrency(
        body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/CurrencyData`;
            return super.update(body, '');
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public getParameterData(): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/Parameters/list`;
            return super.get();
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public updateParameterData(
        body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/Parameters`;
            return super.update(body, '');
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public createParameterData(
        body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/Parameters`;
            return super.create(body);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public getPDMORegulations(): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/PDMORegulations/list`;
            return super.get();
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public updatePDMORegulations(body: any,
    ): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/PDMORegulations`;
            return super.update(body, '');
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    public createSendMail(
        body: any,
    ): Promise<IApiResponse | void> {
        // เพิ่ม flag เพื่อควบคุมการส่งอีเมล
        const skipSendingEmail = true;
        
        if (skipSendingEmail) {
            return Promise.resolve();
        }
        
        try {
            this.url = `${url}/SendMail`;
            return super.create(body);
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

}
const systemHelperAPI = new SystemHelperService(url);
export default systemHelperAPI;
